<template>
    <div style="background-color: transparent;">
        <div class="sa-ft-modern-clinical">
            <section class="sa-ft-section-container">
                <div class="sa-ft-form-card">
                    <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">📝</div>
                        <h3>Anagrafica Assistito</h3>
                        <div class="sa-ft-status-dot-complete" v-if="isAnagraficaAssistitoComplete"></div>
                        <div class="sa-ft-status-dot-not-complete" v-else></div>
                    </div>
                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🆔</div>
                            <div class="sa-ft-inner-row">
                                <div class="sa-ft-inner-column flex-main">
                                    <label class="sa-ft-form-label">Codice Fiscale</label>
                                    <input class="sa-ft-form-input" type="text" @input="emitChange()"
                                        v-model="jsonData.accettazione.accettazioneAnagrafica.identificativo"
                                        :disabled="!isEdit">
                                </div>
                                <button v-if="!jsonData.id || jsonData.id == '-1'" type="button"
                                    @click="onRicercaAssistito" class="sa-ft-action-btn primary">
                                    <span>Verifica</span>
                                    <small>🔍</small>
                                </button>

                            </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">👤</div>
                            <div class="sa-ft-data">
                                <label>Cognome</label>
                                <input v-model="jsonData.accettazione.accettazioneAnagrafica.cognome"
                                    @input="emitChange()" :disabled="!isEdit" type="text">
                            </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">👤</div>
                            <div class="sa-ft-data">
                                <label>Nome</label>
                                <input v-model="jsonData.accettazione.accettazioneAnagrafica.nome" :disabled="!isEdit"
                                    @input="emitChange()" type="text">
                            </div>
                        </div>

                    </div>


                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-2">
                            <div class="sa-ft-data">
                                <label>Prov.</label>
                                <select :disabled="!isEdit"
                                    v-model="jsonData.accettazione.accettazioneAnagrafica.provinciaNascita"
                                    @change="emitChange()" class="sa-ft-form-select">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="prov, i in provinciaNascitaOptions" :key="i" :value="prov.sigla">
                                        {{ prov.provincia }}
                                    </option>
                                </select>

                            </div>
                        </div>
                        <div class="sa-ft-field flex-2">
                            <div class="sa-ft-data">
                                <label>Comune</label>
                                <select :disabled="!isEdit"
                                    v-model="jsonData.accettazione.accettazioneAnagrafica.comuneNascitaCodiceIstat"
                                    @change="emitChange()" class="sa-ft-form-select">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="com, i in comuniNascitaOptions" :key="i" :value="com.codiceIstat">
                                        {{ com.comune }}
                                    </option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">📅</div>
                            <div class="sa-ft-data">
                                <label>Data di Nascita</label>
                                <date-picker type="date"
                                    v-model="jsonData.accettazione.accettazioneAnagrafica.dataNascita"
                                    value-type="timestamp" format="DD/MM/YYYY" placeholder="Seleziona Data"
                                    :disabled="!isEdit" @input="emitChange()" class="sa-ft-date-input">
                                </date-picker>
                            </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🚻</div>
                            <div class="sa-ft-data">
                                <label>Sesso</label>
                                <select :disabled="!isEdit" v-model="jsonData.accettazione.accettazioneAnagrafica.sesso"
                                    @change="emitChange()" class="sa-ft-form-select">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="sess, i in sessoOption" :key="i" :value="sess.value">
                                        {{ sess.text }}
                                    </option>
                                </select>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="sa-ft-section-container">
                <div class="sa-ft-form-card">
                    <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">📞</div>
                        <h3>Contatti</h3>
                        <div class="sa-ft-status-dot-complete" v-if="isContattiComplete"></div>
                        <div class="sa-ft-status-dot-not-complete" v-else></div>
                    </div>

                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">📱</div>
                            <div class="sa-ft-data">
                                <label>Cellulare</label>
                                <input type="text" :disabled="!isEdit" @input="emitChange()"
                                    v-model="jsonData.accettazione.accettazioneAnagrafica.telefono" value="ROSSI">
                            </div>
                        </div>
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">📩</div>
                            <div class="sa-ft-data">
                                <label>Email</label>
                                <input type="text" :disabled="!isEdit" @input="emitChange()"
                                    v-model="jsonData.accettazione.accettazioneAnagrafica.email" value="ROSSI">
                            </div>
                        </div>

                    </div>

                </div>
            </section>

            <section class="sa-ft-section-container">
                <div class="sa-ft-form-card">
                    <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">📍</div>
                        <h3>Recapiti Territoriali</h3>
                        <div class="sa-ft-status-dot-complete" v-if="isRecapitiTerritorialiComplete"></div>
                        <div class="sa-ft-status-dot-not-complete" v-else></div>
                    </div>
                    <div class="sa-ft-split-wrapper">
                        <div class="sa-ft-split-column">
                            <div class="sa-ft-sub-label">Residenza</div>
                            <div class="sa-ft-grid-vertical">
                                <div class="sa-ft-field">
                                    <div class="sa-ft-icon-box">🏠</div>
                                    <div class="sa-ft-data">
                                        <div class="sa-ft-inner-row">
                                            <div class="sa-ft-inner-column flex-main">
                                                <label>Indirizzo</label>
                                                <input type="text" :disabled="!isEdit" @input="emitChange()"
                                                    v-model="jsonData.accettazione.accettazioneAnagrafica.indirizzoResidenza"
                                                    placeholder="Via e civico">
                                            </div>
                                            <div class="sa-ft-inner-divider"></div>
                                            <div class="sa-ft-inner-column flex-fixed-cap">
                                                <label>Cap</label>
                                                <input type="text" :disabled="!isEdit" @input="emitChange()"
                                                    v-model="jsonData.accettazione.accettazioneAnagrafica.capResidenza"
                                                    maxlength="5">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Regione</label>
                                            <select :disabled="!isEdit"
                                                v-model="jsonData.accettazione.accettazioneAnagrafica.regioneResidenza"
                                                @change="emitChange()" class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="regione, i in regioniResidenzaOptions" :key="i"
                                                    :value="regione.codiceIstat">
                                                    {{ regione.regione }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Prov.</label>
                                            <select :disabled="!isEdit"
                                                v-model="jsonData.accettazione.accettazioneAnagrafica.provinciaResidenza"
                                                @change="emitChange()" class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="provincia, i in provinceResidenzaOptions" :key="i"
                                                    :value="provincia.sigla">
                                                    {{ provincia.provincia }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Comune</label>
                                            <select :disabled="!isEdit"
                                                v-model="jsonData.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat"
                                                :options="comuniResidenzaOptions" @change="emitChange()"
                                                class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="comune, i in comuniResidenzaOptions" :key="i"
                                                    :value="comune.codiceIstat">
                                                    {{ comune.comune }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="sa-ft-divider-vertical"></div>

                        <div class="sa-ft-split-column">
                            <div class="sa-ft-sub-header-row">
                                <div class="sa-ft-sub-label">Domicilio</div>
                                <b-form-checkbox :disabled="!isEdit" switch v-model="isDomicilioUgualeResidenza"
                                    class="sa-ft-switch-sm">
                                    Coincide
                                </b-form-checkbox>
                            </div>

                            <div class="sa-ft-grid-vertical" :style="{ opacity: isDomicilioUgualeResidenza ? 0.6 : 1 }">
                                <div class="sa-ft-field">
                                    <div class="sa-ft-icon-box">📍</div>
                                    <div class="sa-ft-data">
                                        <div class="sa-ft-inner-row">
                                            <div class="sa-ft-inner-column flex-main">
                                                <label>Indirizzo Domicilio</label>
                                                <input type="text" @input="emitChange()"
                                                    v-model="jsonData.accettazione.accettazioneAnagrafica.indirizzoDomicilio"
                                                    :disabled="isDomicilioUgualeResidenza || !isEdit">
                                            </div>
                                            <div class="sa-ft-inner-divider"></div>
                                            <div class="sa-ft-inner-column flex-fixed-cap">
                                                <label>Cap</label>
                                                <input type="text" @input="emitChange()"
                                                    v-model="jsonData.accettazione.accettazioneAnagrafica.capDomicilio"
                                                    :disabled="isDomicilioUgualeResidenza || !isEdit">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Regione</label>
                                            <select
                                                v-model="jsonData.accettazione.accettazioneAnagrafica.regioneDomicilio"
                                                @change="emitChange()" :disabled="isDomicilioUgualeResidenza || !isEdit"
                                                class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="regione, i in regioniDomicilioOptions" :key="i"
                                                    :value="regione.codiceIstat">
                                                    {{ regione.regione }}
                                                </option>
                                            </select>

                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Prov.</label>
                                            <select
                                                v-model="jsonData.accettazione.accettazioneAnagrafica.provinciaDomicilio"
                                                @change="emitChange(), onChangeProvinciaNascita()"
                                                :disabled="isDomicilioUgualeResidenza || !isEdit"
                                                class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="provincia, i in provinceDomicilioOptions" :key="i"
                                                    :value="provincia.sigla">
                                                    {{ provincia.provincia }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Comune</label>
                                            <select
                                                v-model="jsonData.accettazione.accettazioneAnagrafica.comuneDomicilioCodiceIstat"
                                                @change="emitChange()" :disabled="isDomicilioUgualeResidenza || !isEdit"
                                                class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="comune, i in comuniDomicilioOptions" :key="i"
                                                    :value="comune.codiceIstat">
                                                    {{ comune.comune }}
                                                </option>
                                            </select>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sa-ft-split-wrapper mt-4">
                        <div class="sa-ft-split-column">
                            <div class="sa-ft-sub-label">ASL Residenza </div>
                            <div class="sa-ft-grid-vertical">
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-2">

                                        <div class="sa-ft-data">
                                            <label>Codice A.S.L.</label>
                                            <input type="text"
                                                v-model="jsonData.accettazione.accettazioniAsl.aslResidenzaCodice"
                                                @input="emitChange()" :disabled="!isEdit">
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>A.S.L.</label>
                                            <input type="text"
                                                v-model="jsonData.accettazione.accettazioniAsl.aslResidenzaDenominazione"
                                                @input="emitChange()" :disabled="!isEdit">
                                        </div>
                                    </div>

                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Ambito</label>
                                            <select v-model="jsonData.accettazione.accettazioniAsl.aslResidenzaAmbito"
                                                @change="emitChange()" :disabled="!isEdit" class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="ambito, i in ambitiAslResidenzaOptions" :key="i"
                                                    :value="ambito.value">
                                                    {{ ambito.text }}
                                                </option>
                                            </select>


                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Distretto</label>
                                            <select
                                                v-model="jsonData.accettazione.accettazioniAsl.aslResidenzaDistretto"
                                                @change="emitChange()" :disabled="!isEdit" class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="distretto, i in distrettiAslResidenzaOptions" :key="i"
                                                    :value="distretto.descrizione">
                                                    {{ distretto.descrizione }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="sa-ft-divider-vertical"></div>

                        <div class="sa-ft-split-column">
                            <div class="sa-ft-sub-header-row">
                                <div class="sa-ft-sub-label">ASL Domicilio</div>

                            </div>

                            <div class="sa-ft-grid-vertical" :style="{ opacity: isDomicilioUgualeResidenza ? 0.6 : 1 }">
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-2">

                                        <div class="sa-ft-data">
                                            <label>Codice A.S.L.</label>
                                            <input type="text"
                                                v-model="jsonData.accettazione.accettazioniAsl.aslDomicilioCodice"
                                                @input="emitChange()" :disabled="isDomicilioUgualeResidenza || !isEdit">
                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>A.S.L.</label>
                                            <input type="text"
                                                v-model="jsonData.accettazione.accettazioniAsl.aslDomicilioDenominazione"
                                                @input="emitChange()" :disabled="isDomicilioUgualeResidenza || !isEdit">
                                        </div>
                                    </div>

                                </div>
                                <div class="sa-ft-grid">
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Ambito</label>
                                            <select v-model="jsonData.accettazione.accettazioniAsl.aslDomicilioAmbito"
                                                @change="emitChange()" :disabled="isDomicilioUgualeResidenza || !isEdit"
                                                class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="ambito, i in ambitiAslDomicilioOptions" :key="i"
                                                    :value="ambito.value">
                                                    {{ ambito.text }}
                                                </option>
                                            </select>

                                        </div>
                                    </div>
                                    <div class="sa-ft-field flex-2">
                                        <div class="sa-ft-data">
                                            <label>Distretto</label>
                                            <select
                                                v-model="jsonData.accettazione.accettazioniAsl.aslDomicilioDistretto"
                                                @change="emitChange()" :disabled="isDomicilioUgualeResidenza || !isEdit"
                                                class="sa-ft-form-select">
                                                <option :value="null" disabled>- Seleziona -</option>
                                                <option v-for="distretto, i in distrettiAslDomicilioOptions" :key="i"
                                                    :value="distretto.codiceDistretto">
                                                    {{ distretto.descrizione }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="sa-ft-section-container">
                <div class="sa-ft-form-card">
                    <div class="sa-ft-card-header">
                        <div class="sa-ft-section-icon">📋</div>
                        <h3>Informazioni Aggiuntive e Documenti</h3>
                        <div class="sa-ft-status-dot-complete" v-if="isAnagraficaAssistitoComplete"></div>
                        <div class="sa-ft-status-dot-not-complete" v-else></div>
                    </div>

                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">💍</div>
                            <div class="sa-ft-data">
                                <label>Stato Civile <span class="text-danger">*</span></label>
                                <select class="sa-ft-form-select" v-model="jsonData.statoCivile" :disabled="!isEdit"
                                    @change="emitChange()">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="statocivile, i in statoCivileOptions" :key="i"
                                        :value="statocivile.descrizione">
                                        {{ statocivile.descrizione }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🌍</div>
                            <div class="sa-ft-data">
                                <label>Cittadinanza</label>
                                <select class="sa-ft-form-select" v-model="jsonData.cittadinanza" :disabled="!isEdit"
                                    @change="emitChange()">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="nazione, i in cittadinanzeOptions" :key="i"
                                        :value="nazione.istatStato">
                                        {{ nazione.cittadinanza }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">💼</div>
                            <div class="sa-ft-data">
                                <label>Partita IVA</label>
                                <input type="text" @input="emitChange()" class="sa-ft-form-input"
                                    v-model="jsonData.partitaIva" placeholder="" :disabled="!isEdit" />
                            </div>
                        </div>
                    </div>

                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">📄</div>
                            <div class="sa-ft-data">
                                <label>Tipologia Documento</label>
                                <select class="sa-ft-form-select" v-model="jsonData.tipologiaDocumento"
                                    :disabled="!isEdit" @change="emitChange()">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="doc, i in tipologiaDocumentoOptions" :key="i" :value="doc">
                                        {{ doc }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🔢</div>
                            <div class="sa-ft-data">
                                <label>Numero Documento</label>
                                <input type="text" class="sa-ft-form-input" v-model="jsonData.documento" placeholder=""
                                    :disabled="!isEdit" @input="emitChange()" />
                            </div>
                        </div>

                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">🏛️</div>
                            <div class="sa-ft-data">
                                <label>Rilasciato Da</label>
                                <select class="sa-ft-form-select" v-model="jsonData.rilasciatoDa" :disabled="!isEdit"
                                    @change="emitChange()">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="rilas, i in rilasciatoDaOptions" :key="i" :value="rilas">
                                        {{ rilas }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-2">
                            <div class="sa-ft-icon-box">⏳</div>
                            <div class="sa-ft-data">
                                <label>Scadenza Documento</label>
                                <date-picker type="date" v-model="jsonData.scadenzaTessera" value-type="timestamp"
                                    format="DD/MM/YYYY" placeholder="Seleziona Data" :disabled="!isEdit"
                                    @input="emitChange()" class="sa-ft-date-input">
                                </date-picker>
                            </div>
                        </div>
                        <div class="sa-ft-field flex-2">
                            <div class="sa-ft-icon-box">👥</div>
                            <div class="sa-ft-data">
                                <label>Gruppo</label>
                                <select class="sa-ft-form-select" v-model="jsonData.gruppo" :disabled="!isEdit"
                                    @change="emitChange()">
                                    <option :value="null" disabled>- Seleziona -</option>
                                    <option v-for="gruppo, i in gruppoOptions" :key="i" :value="gruppo.nome">
                                        {{ gruppo.nome }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="sa-ft-grid">
                        <div class="sa-ft-field flex-1">
                            <div class="sa-ft-icon-box">📝</div>
                            <div class="sa-ft-data">
                                <label>Note Caratteristiche Paziente</label>
                                <b-form-textarea class="sa-ft-form-textarea"
                                    v-model="jsonData.noteCaratteristichePaziente"
                                    placeholder="Inserire eventuali note cliniche o logistiche..." rows="4" max-rows="5"
                                    :disabled="!isEdit" @input="emitChange()" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>


</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    props: {
        initJsonData: {
            type: Object,
            default: () => {
                return null;
            },
        },
        isEdit: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
        isActionAnagrafica: {
            type: Boolean,
            default: () => {
                return false;
            },
        }
    },
    mixins: [UtilityMixin],
    data() {
        return {
            linkRegioni: "/regioni",
            linkProvince: "/province",
            linkComune: "/comuni/provincia",
            linkComuneIstat: "/comuni/istat",
            linkAslResouce: "/asl/comune",
            pathResourceAmbiti: "/serviziambiticomuni",
            pathResourceDistretti: "/servizidistretticomuni",
            jsonData: {
                accettazione: {
                    accettazioneAnagrafica: {
                        identificativo: null,
                        cognome: null,
                        nome: null,
                        dataNascita: new Date().getTime(),
                        sesso: null,
                        provinciaNascita: null,
                        comuneNascitaCodiceIstat: null,
                        comuneNascita: null,
                        distretto: null,
                        quartiere: null,
                        regione: null,
                        regioneResidenza: null,
                        provinciaResidenza: null,
                        comuneResidenzaCodiceIstat: null,
                        indirizzoResidenza: null,
                        capResidenza: null,
                        regioneDomicilio: null,
                        provinciaDomicilio: null,
                        comuneDomicilioCodiceIstat: null,
                        indirizzoDomicilio: null,
                        capDomicilio: null,
                    },
                    accettazioniAsl: {
                        aslResidenzaCodice: null,
                        aslResidenzaDenominazione: null,
                        aslResidenzaAmbito: null,
                        aslResidenzaDistretto: null,
                        aslDomicilioCodice: null,
                        aslDomicilioDenominazione: null,
                        aslDomicilioAmbito: null,
                        aslDomicilioDistretto: null,
                    },
                },
                id: null,
                primaryKey: null,
                idAccettazione: null,
                tipo: null,
                gruppoSanguigno: null,
                createDate: null,
                createUser: null,
                proprietario: null,
                cittadinanza: null,
                statoCivile: null,
                anonimato: true,
                stp: false,
                eni: true,
                conv: false,
                team: true,
                emailBox: true,
                sconosciuto: false,
                noteCaratteristichePaziente: null,
                rilasciatoDa: null,
                documento: null,
                partitaIva: null,
                identificazioneIstituzione: null,
                tipologiaDocumento: null,
                identificazioneTessera: null,
                scadenzaStpEni: null,
                scadenzaTessera: null,
                note: "",
            },

            rules: {
                identificativo: {
                    msg: "Identificativo non valido",
                    rule: (val) => val != null && val.length >= 3,
                },
                cognome: {
                    msg: "Cognome non valido",
                    rule: (val) => val != null && val != null && val.length >= 3,
                },
                nome: {
                    msg: "Nome non valido",
                    rule: (val) => val != null && val.length >= 3,
                },
                sesso: {
                    msg: "Sesso non valido",
                    rule: (val) => val != null,
                },
                provinciaNascita: {
                    msg: "Provincia Nascita non valida",
                    rule: (val) => val != null,
                },
                comuneNascitaCodiceIstat: {
                    msg: "Comune Nascita non valido",
                    rule: (val) => val != null,
                },
                telefono: {
                    msg: "Telefono non valido",
                    rule: (val) => val != null && val.length <= 11,
                },
                email: {
                    msg: "Email non valido",
                    rule: (val) => val != null,
                },
                regioneResidenza: {
                    msg: "Regione Residenza non valida",
                    rule: (val) => val != null,
                },
                provinciaResidenza: {
                    msg: "Provincia Residenza non valida",
                    rule: (val) => val != null,
                },
                comuneResidenzaCodiceIstat: {
                    msg: "Comune Residenza non valido",
                    rule: (val) => val != null,
                },
                capResidenza: {
                    msg: "Cap Residenza non valido",
                    rule: (val) => val != null,
                },
                indirizzoResidenza: {
                    msg: "Indirizzo Residenza non valido",
                    rule: (val) => val != null,
                },
                regioneDomicilio: {
                    msg: "Regione Domicilio non valida",
                    rule: (val) => val != null,
                },
                provinciaDomicilio: {
                    msg: "Provincia Domicilio non valida",
                    rule: (val) => val != null,
                },
                comuneDomicilioCodiceIstat: {
                    msg: "Comune Domicilio non valido",
                    rule: (val) => val != null,
                },
                capDomicilio: {
                    msg: "Cap Domicilio non valido",
                    rule: (val) => val != null,
                },
                indirizzoDomicilio: {
                    msg: "Indirizzo Domicilio non valido",
                    rule: (val) => val != null,
                },
            },
            linkGruppiSangue: "/pazientigruppisanguigno",
            isDomicilioUgualeResidenza: false,
            nazionalitaOptions: [],
            aslOptions: [],
            quartiereOptions: [],
            regioniResidenzaOptions: [],
            regioniDomicilioOptions: [],
            provinciaOptions: [],
            gruppoOptions: [],
            provinciaNascitaOptions: [],
            distrettiAslResidenzaOptions: [],
            distrettiAslDomicilioOptions: [],
            provinceResidenzaOptions: [],
            statoCivileOptions: [],
            provinceDomicilioOptions: [],
            distrettiOptions: [],
            ambitiAslResidenzaOptions: [],
            ambitiAslDomicilioOptions: [],
            isResidenzaUgualeDomicilio: false,
            comuniNascitaOptions: [],
            comuniResidenzaOptions: [],
            comuniDomicilioOptions: [],
            gruppoSanguignoOption: [],
            tipologiaDocumentoOptions: ["Carta d'identita'", "Passaporto", "Patente di guida"],
            rilasciatoDaOptions: ["Ministero dell'Interno", "IPZS", "Comuni", "Polizia di Stato", "Altre Pubbliche Amministrazioni"],
            cittadinanzeOptions: [],
            sessoOption: [
                { text: "Maschio", value: "M" },
                { text: "Femmina", value: "F" },
                { text: "Altro", value: "A" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadRegioni();
        me.loadProvinceNascita();
        me.loadGruppiSangue();
        me.loadGruppoAccettazioneSsn();
        this.loadCittadinzanza();
        this.onLoadStatiCivili();
        if (this.initJsonData) {
            this.jsonData = this.initJsonData;
            this.setJsonData(this.initJsonData);
        }
    },
    computed: {
        isAnagraficaAssistitoComplete() {
            let anagrafica = this.jsonData.accettazione.accettazioneAnagrafica;
            if (anagrafica.identificativo == null || anagrafica.identificativo.trim() == "") {
                return false;
            }
            if (anagrafica.nome == null || anagrafica.nome.trim() == "") {
                return false;
            }
            if (anagrafica.cognome == null || anagrafica.cognome.trim() == "") {
                return false;
            }

            if (anagrafica.sesso == null || anagrafica.sesso.trim() == "") {
                return false;
            }
            if (anagrafica.comuneNascitaCodiceIstat == null || anagrafica.comuneNascitaCodiceIstat.trim() == "") {
                return false;
            }
            if (anagrafica.provinciaNascita == null || anagrafica.provinciaNascita.trim() == "") {
                return false;
            }
            return true;
        },
        isContattiComplete() {
            let anagrafica = this.jsonData.accettazione.accettazioneAnagrafica;
            if (anagrafica.telefono == null || anagrafica.telefono.trim() == "") {
                return false;
            }
            if (anagrafica.email == null || anagrafica.email.trim() == "") {
                return false;
            }
            return true;
        },
        isRecapitiTerritorialiComplete() {
            let anagrafica = this.jsonData.accettazione.accettazioneAnagrafica;
            let asl = this.jsonData.accettazione.accettazioniAsl;
            if (anagrafica.indirizzoResidenza == null || anagrafica.indirizzoResidenza.trim() == "") {
                return false;
            }
            if (anagrafica.capResidenza == null || anagrafica.capResidenza.trim() == "") {
                return false;
            }
            if (anagrafica.regioneResidenza == null || anagrafica.regioneResidenza.trim() == "") {
                return false;
            }
            if (anagrafica.provinciaResidenza == null || anagrafica.provinciaResidenza.trim() == "") {
                return false;
            }
            if (anagrafica.comuneResidenzaCodiceIstat == null || anagrafica.comuneResidenzaCodiceIstat.trim() == "") {
                return false;
            }
            if (asl.aslResidenzaCodice == null || asl.aslResidenzaCodice.trim() == "") {
                return false;
            }
            if (asl.aslResidenzaDenominazione == null || asl.aslResidenzaDenominazione.trim() == "") {
                return false;
            }
            if (asl.aslResidenzaAmbito == null || asl.aslResidenzaAmbito.trim() == "") {
                return false;
            }
            if (asl.aslResidenzaDistretto == null || asl.aslResidenzaDistretto.trim() == "") {
                return false;
            }

            if (this.isDomicilioUgualeResidenza) {
                return true
            } else {
                if (anagrafica.indirizzoDomicilio == null || anagrafica.indirizzoDomicilio.trim() == "") {
                    return false;
                }
                if (anagrafica.capDomicilio == null || anagrafica.capDomicilio.trim() == "") {
                    return false;
                }
                if (anagrafica.regioneDomicilio == null || anagrafica.regioneDomicilio.trim() == "") {
                    return false;
                }
                if (anagrafica.provinciaDomicilio == null || anagrafica.provinciaDomicilio.trim() == "") {
                    return false;
                }
                if (anagrafica.comuneDomicilioCodiceIstat == null || anagrafica.comuneDomicilioCodiceIstat.trim() == "") {
                    return false;
                }
                if (asl.aslDomicilioCodice == null || asl.aslDomicilioCodice.trim() == "") {
                    return false;
                }
                if (asl.aslDomicilioDenominazione == null || asl.aslDomicilioDenominazione.trim() == "") {
                    return false;
                }
                if (asl.aslDomicilioAmbito == null || asl.aslDomicilioAmbito.trim() == "") {
                    return false;
                }
                if (asl.aslDomicilioDistretto == null || asl.aslDomicilioDistretto.trim() == "") {
                    return false;
                }
            }



            return true;
        },
    },
    watch: {
        isDomicilioUgualeResidenza() {
            let me = this;
            me.setDomicilio();
        },

        "jsonData.accettazione.accettazioneAnagrafica.provinciaNascita": function (params) {
            let me = this;
            me.loadComuni(params, "nascita");
        },
        "jsonData.accettazione.accettazioneAnagrafica.regioneResidenza": function (params) {
            let me = this;
            me.onChangeRegioneResidenza(params);
        },
        "jsonData.accettazione.accettazioneAnagrafica.provinciaResidenza": function (param) {
            let me = this;
            me.onChangeProvinciaResidenza(param);
        },
        "jsonData.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat": function (param) {
            let me = this;
            me.onChangeComuneResidenza(param);
        },
        "jsonData.accettazione.accettazioneAnagrafica.regioneDomicilio": function (params) {
            let me = this;
            me.onChangeRegioniDomicilio(params);
        },
        "jsonData.accettazione.accettazioneAnagrafica.provinciaDomicilio": function (params) {
            let me = this;
            me.onChangeProvinciaDomicilio(params);
        },
        "jsonData.accettazione.accettazioneAnagrafica.comuneDomicilioCodiceIstat": function (params) {
            let me = this;
            me.onChangeComuneDomicilio(params);
        },
    },
    methods: {
        init(jsonData) {
            this.jsonData = jsonData;
        },
        onChangeProvinciaNascita(value) {
            let me = this;
            me.comuniNascitaOptions = [];
            me.comuniNascitaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(value, "nascita");
        },
        onRicercaAssistito() {
            console.log("this.jsonData", this.jsonData);
        },
        setJsonData(json) {
            console.log(json);
        },

        getJsonData() {
            return this.jsonData;
        },

        onLoadStatiCivili() {
            let me = this;
            me.statoCivileOptions = [];
            UtilityMixin.methods.loadDataResources("/anagraficastaticivili", {}, me.onLoadStatiCiviliSuccess, me.onLoadStatiCiviliError);
        },
        onLoadStatiCiviliSuccess(response) {
            let me = this;

            me.statoCivileOptions = response.data.data.list;
        },
        onLoadStatiCiviliError(err) {
            err;
        },
        loadCittadinzanza() {

            let link = process.env.VUE_APP_PATH_API + "/nazionalita";
            axios
                .get(link)
                .then((response) => {
                    console.log(response);

                    this.cittadinanzeOptions = response.data.data.list;

                })
        },
        loadAmbitiAsl(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbiti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        switch (destination) {
                            case "residenza":
                                me.ambitiAslResidenzaOptions = [];
                                me.ambitiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                                if (response.data.data.list.length === 1) {
                                    me.jsonData.accettazione.accettazioniAsl.aslResidenzaAmbito = response.data.data.list[0].codiceAmbito;
                                }

                                break;
                            case "domicilio":
                                me.ambitiAslDomicilioOptions = [];
                                me.ambitiAslDomicilioOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                                if (response.data.data.list.length === 1) {
                                    me.jsonData.accettazione.accettazioniAsl.aslDomicilioAmbito = response.data.data.list[0].codiceAmbito;
                                }

                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log(error);

                });
        },
        stampaJson() { },
        loadGruppiSangue() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkGruppiSangue;
            me.gruppoSanguignoOption = [];
            axios.get(link).then((response) => {
                response.data.data.forEach((element) => {
                    me.gruppoSanguignoOption.push({ value: element.descrizione, text: this.$i18n.t(element.descrizione) });
                });
                me.gruppoSanguignoOption.unshift({ value: null, text: "-Seleziona Valore-" });
            });
        },
        loadGruppoAccettazioneSsn() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/accettazionessngruppi";
            me.gruppoOptions = [];
            axios.get(link).then((response) => {
                me.gruppoOptions = response.data.data.list;
            });
        },
        getStateValidationField(fieldName) {
            let me = this;
            const field = me.jsonData[fieldName];
            if (field === null) {
                return null;
            }
            const rules = me.rules[fieldName];
            if (!rules) {
                return true;
            }
            return rules.rule(field);
        },

        getMsg(fieldName) {
            let me = this;
            const fieldValue = me.jsonData[fieldName];
            const valid = me.getStateValidationField(fieldName);
            const rules = me.rules[fieldName];
            if ((fieldValue && !valid) || fieldValue == null) {
                if (rules) return rules.msg;
            }
            return null;
        },
        emitChange() {
            let me = this;
            me.$emit("changeJsonData", this.jsonData);
        },
        loadProvinceNascita() {
            let me = this;
            me.provinciaNascitaOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.linkProvince;
            axios
                .get(link)
                .then((response) => {
                    me.provinciaNascitaOptions = response.data.data;
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        setDomicilio() {
            let me = this;
            if (me.isDomicilioUgualeResidenza) {
                me.jsonData.accettazione.accettazioneAnagrafica.regioneDomicilio = me.jsonData.accettazione.accettazioneAnagrafica.regioneResidenza;
                me.jsonData.accettazione.accettazioneAnagrafica.provinciaDomicilio = me.jsonData.accettazione.accettazioneAnagrafica.provinciaResidenza;
                me.jsonData.accettazione.accettazioneAnagrafica.comuneDomicilioCodiceIstat = me.jsonData.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat;
                me.jsonData.accettazione.accettazioneAnagrafica.capDomicilio = me.jsonData.accettazione.accettazioneAnagrafica.capResidenza;
                me.jsonData.accettazione.accettazioneAnagrafica.indirizzoDomicilio = me.jsonData.accettazione.accettazioneAnagrafica.indirizzoResidenza;
                me.jsonData.accettazione.accettazioniAsl.aslDomicilioCodice = me.jsonData.accettazione.accettazioniAsl.aslResidenzaCodice
                me.jsonData.accettazione.accettazioniAsl.aslDomicilioDenominazione = me.jsonData.accettazione.accettazioniAsl.aslResidenzaDenominazione
                me.jsonData.accettazione.accettazioniAsl.aslDomicilioAmbito = me.jsonData.accettazione.accettazioniAsl.aslResidenzaAmbito
                me.jsonData.accettazione.accettazioniAsl.aslDomicilioDistretto = me.jsonData.accettazione.accettazioniAsl.aslResidenzaDistretto
                me.emitChange();
            }
        },
        onChangeRegioneResidenza(regione) {
            let me = this;
            me.provinceResidenzaOptions = [];
            me.loadProvince(regione, "residenza");
            me.setDomicilio();
            me.emitChange();
        },

        onChangeProvinciaResidenza(provincia) {
            let me = this;
            me.comuniResidenzaOptions = [];
            me.loadComuni(provincia, "residenza");
            me.setDomicilio();
            me.emitChange();
        },
        onChangeComuneResidenza(value) {
            let me = this;
            me.loadCap(value, "residenza");
            me.loadAsl(value, "residenza");
            me.loadDistrettiAsl(value, "residenza");
            me.loadAmbitiAsl(value, "residenza");
            me.setDomicilio();
            me.emitChange();
        },
        onChangeRegioniDomicilio(regione) {
            let me = this;
            me.provinceDomicilioOptions = [];
            me.loadProvince(regione, "domicilio");
            me.emitChange();
        },
        onChangeProvinciaDomicilio(provincia) {
            let me = this;
            me.comuniDomicilioOptions = [];
            me.loadComuni(provincia, "domicilio");
        },
        onChangeComuneDomicilio(value) {
            let me = this;
            me.loadCap(value, "domicilio");
            me.loadAsl(value, "domicilio");
            me.loadDistrettiAsl(value, "domicilio");
            me.loadAmbitiAsl(value, "domicilio");
            me.emitChange();
        },
        loadDistrettiAsl(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDistretti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    //      response.data.data.list.forEach((element) => {
                    switch (destination) {
                        case "residenza":
                            me.distrettiAslResidenzaOptions = [];
                            me.distrettiAslResidenzaOptions = response.data.data.list;
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazione.accettazioniAsl.aslResidenzaDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            break;
                        case "domicilio":
                            me.distrettiAslDomicilioOptions = [];
                            me.distrettiAslDomicilioOptions = response.data.data.list;
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazione.accettazioniAsl.aslDomicilioDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            break;
                    }
                    //  });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
        onInputCapResidenza() {
            let me = this;
            me.setDomicilio();
            me.emitChange();
        },
        onInputIndirizzoResidenza() {
            let me = this;
            me.setDomicilio();
            me.emitChange();
        },
        loadProvince(regione, destination) {
            let me = this;
            if (destination) {
                me.filtro = { regione: regione };
            } else {
                me.filtro = null;
            }
            let link = process.env.VUE_APP_PATH_API + me.linkProvince;
            axios.get(link, { params: me.filtro }).then((response) => {
                response.data.data.forEach((provincia) => {
                    switch (destination) {
                        case "residenza":
                            me.provinceResidenzaOptions.push(provincia);
                            break;
                        case "domicilio":
                            me.provinceDomicilioOptions.push(provincia);
                            break;
                    }
                });
                if (me.id !== "-1") {
                    me.setRegioni();
                }
            });
        },
        loadComuni(sigla, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;




            switch (destination) {
                case "nascita":

                    me.comuniNascitaOptions = [];
                    break;
                case "residenza":

                    me.comuniResidenzaOptions = [];
                    break;
                case "domicilio":

                    me.comuniDomicilioOptions = [];
                    break;
            }
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        switch (destination) {
                            case "nascita":

                                me.comuniNascitaOptions.push(comune);
                                break;
                            case "residenza":

                                me.comuniResidenzaOptions.push(comune);
                                break;
                            case "domicilio":

                                me.comuniDomicilioOptions.push(comune);
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadCap(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkComuneIstat + "/" + codiceIstat;
            if (codiceIstat) {
                axios
                    .get(link)
                    .then((response) => {
                        switch (destination) {
                            case "residenza":
                                me.jsonData.accettazione.accettazioneAnagrafica.capResidenza = response.data.data.cap;

                                break;
                            case "domicilio":
                                me.jsonData.accettazione.accettazioneAnagrafica.capDomicilio = response.data.data.cap;
                                break;
                        }
                    })
                    .catch((error) => {
                        console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                    });
            }
        },
        loadRegioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkRegioni;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((regione) => {
                        me.regioniResidenzaOptions.push(regione);
                        me.regioniDomicilioOptions.push(regione);
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadComune(sigla) {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            axios.get(link).then((response) => {
                me.comuniNascitaOptions = [];
                response.data.data.forEach((element) => {
                    me.comuniNascitaOptions.push({
                        value: element.codiceIstat,
                        text: element.comune,
                    });
                });
            });
            me.emitChange();
        },
        loadAsl(codiceIstat, destination) {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.linkAslResouce;
            let params = { istatComune: codiceIstat };
            if (codiceIstat) {
                axios
                    .get(link, { params: params })
                    .then((response) => {
                        if (response.data.data !== null) {
                            switch (destination) {
                                case "residenza":
                                    this.jsonData.accettazione.accettazioniAsl.aslResidenzaCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    this.jsonData.accettazione.accettazioniAsl.aslResidenzaDenominazione = response.data.data.denominazione;

                                    break;
                                case "domicilio":
                                    this.jsonData.accettazione.accettazioniAsl.aslDomicilioCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    this.jsonData.accettazione.accettazioniAsl.aslDomicilioDenominazione = response.data.data.denominazione;
                                    break;
                            }
                            me.emitChange();
                        }
                    })
                    .catch((error) => {
                        console.log(" errore: " + error.response.status);
                    });
            }
        },
        setRegioni() {
            let me = this;
            me.provinceResidenzaOptions.forEach((element) => {
                if (element.sigla === me.jsonData.accettazione.accettazioneAnagrafica.provinciaResidenza) {
                    if (me.jsonData.accettazione.accettazioneAnagrafica.regioneResidenza === null || me.jsonData.accettazione.accettazioneAnagrafica.regioneResidenza === "") {
                        me.jsonData.accettazione.accettazioneAnagrafica.regioneResidenza = element.regione;
                        me.emitChange();
                    }
                }
                if (element.sigla === me.jsonData.accettazione.accettazioneAnagrafica.provinciaDomicilio) {
                    if (me.jsonData.accettazione.accettazioneAnagrafica.regioneDomicilio === null || me.jsonData.accettazione.accettazioneAnagrafica.regioneDomicilio === "") {
                        me.jsonData.accettazione.accettazioneAnagrafica.regioneDomicilio = element.regione;
                        me.emitChange();
                    }
                }
            });
        },
    },
};
</script>

<style scoped>
/* RESET & CONTAINER GENERALE */
.sa-ft-modern-clinical {
    font-family: 'Inter', sans-serif;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    /* Spazio tra le card */
    background-color: transparent;
    width: 100%;
    box-sizing: border-box;
}

.sa-ft-section-container {
    width: 100%;
}

/* CARD */
.sa-ft-form-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    padding: 20px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.03);
    overflow: hidden;
    /* Taglia eventuali sforamenti */
}

.sa-ft-card-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    gap: 12px;
}

.sa-ft-section-icon {
    font-size: 1.1rem;
    background: #f1f5f9;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.sa-ft-form-card h3 {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 800;
    color: #1e293b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.sa-ft-status-dot-complete {
    width: 8px;
    height: 8px;
    background-color: #10b981;
    border-radius: 50%;
    margin-left: auto;
}

.sa-ft-status-dot-not-complete {
    width: 8px;
    height: 8px;
    background-color: #b91018;
    border-radius: 50%;
    margin-left: auto;
}

/* GRIGLIA E CAMPI (FIELD) */
.sa-ft-grid {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    width: 100%;
}

.sa-ft-grid:last-child {
    margin-bottom: 0;
}

.sa-ft-field {
    display: flex;
    align-items: center;
    background: #f8fafc;
    border: 1px solid #a5a6a8cb;
    border-radius: 12px;
    padding: 8px 14px;
    flex: 1;
    min-height: 52px;
    min-width: 0;
    /* IMPEDISCE LO SFORAMENTO */
    transition: all 0.2s ease;
}

/* FOCUS EFFECT */
.sa-ft-field:focus-within {
    border-color: #00a3ff;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(0, 163, 255, 0.06);
}

.sa-ft-icon-box {
    font-size: 1.1rem;
    margin-right: 12px;
    opacity: 0.6;
}

.sa-ft-data {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    /* IMPEDISCE LO SFORAMENTO */
}

.sa-ft-form-label,
.sa-ft-data label {
    font-size: 0.80rem;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

/* INPUT & SELECT */
.sa-ft-data input[type="text"],
.sa-ft-data select,
.sa-ft-form-input,
.sa-ft-form-textarea,
.sa-ft-form-select {
    border: none !important;
    background: transparent !important;
    font-size: 0.88rem !important;
    font-weight: 600 !important;
    color: #333;
    outline: none;
    padding: 0 !important;
    width: 100% !important;
    min-width: 0 !important;
    /* IMPEDISCE LO SFORAMENTO */
}

/* STILE QUANDO DISABLED */
.sa-ft-data input:disabled,
.sa-ft-data select:disabled,
.sa-ft-form-input:disabled,
.sa-ft-form-textarea:disabled,
.sa-ft-form-select:disabled {
    color: #94a3b8 !important;
    /* Un grigio chiaro (Slate 400) per indicare inattività */
    cursor: not-allowed;
    /* Cambia il cursore */
    opacity: 1;
    /* Reset dell'opacità per iOS/Safari che la abbassano di default */
    -webkit-text-fill-color: #94a3b8;
    /* Fix per alcuni browser mobile */
    background: transparent !important;
}

/* Opzionale: se vuoi togliere la freccetta dalle select quando sono disabilitate */
.sa-ft-form-select:disabled {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}

.sa-ft-date-input {
    cursor: pointer;
    height: 20px !important;
    line-height: 20px !important;
}

.sa-ft-date-input::-webkit-calendar-picker-indicator {
    opacity: 0.5;
    cursor: pointer;
}



.sa-ft-bold {
    font-weight: 800;
}

.sa-ft-alert-field {
    background: #fff8f8;
    border-color: #ffe4e6;
}

.sa-ft-chip-icon {
    margin-right: 8px;
    font-size: 0.9rem;
}

.sa-ft-mt-10 {
    margin-top: 10px;
}

.flex-1 {
    flex: 1;
}

.flex-2 {
    flex: 2;
}

.flex-3 {
    flex: 3;
}

/* SPLIT LAYOUT (RESIDENZA/DOMICILIO) */
.sa-ft-split-wrapper {
    display: flex;
    gap: 20px;
    margin-top: 5px;
    width: 100%;
}

.sa-ft-split-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-width: 0;
    /* IMPEDISCE LO SFORAMENTO */
}

.sa-ft-sub-label {
    font-size: 0.82rem;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.sa-ft-divider-vertical {
    width: 1px;
    background: linear-gradient(to bottom, transparent, #e2e8f0 20%, #e2e8f0 80%, transparent);
}

.sa-ft-sub-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.sa-ft-grid-vertical {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* INNER ROW (INDIRIZZO + CAP) */
.sa-ft-inner-row {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    width: 100%;
}

.sa-ft-inner-column {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.flex-main {
    flex: 1;
}

.flex-fixed-cap {
    width: 60px;
    flex-shrink: 0;
}

.flex-fixed-prov {
    width: 45px;
    flex-shrink: 0;
}

.sa-ft-inner-divider {
    width: 1px;
    height: 20px;
    background-color: #e2e8f0;
    margin-bottom: 4px;
}

/* SMALL SWITCH */
.sa-ft-switch-sm {
    font-size: 0.8rem;
    font-weight: 600;
    color: #64748b;
}

/* Stilizzazione base dell'input date */
.sa-ft-date-input {
    border: none;
    background: transparent;
    font-size: 0.85rem !important;
    font-weight: 600 !important;
    color: #1e293b;
    outline: none;
    padding: 0;
    width: 100%;
    font-family: inherit;
    cursor: pointer;
    appearance: none;
    /* Rimuove stili nativi su alcuni browser */
}

.sa-ft-action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: #00a2ff15;
    /* Sfondo bianco per staccare dal grigio del campo */
    border: 1px solid #00a3ff;
    border-radius: 8px;
    padding: 4px 10px;
    color: #00a3ff;
    /* Colore brand */
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 2px;
    /* Allineamento visuale con l'input */
    white-space: nowrap;
}

.sa-ft-action-btn:hover {
    background-color: #00a3ff;
    color: #ffffff;
    border-color: #00a3ff;
    box-shadow: 0 4px 10px rgba(0, 163, 255, 0.2);
}

.sa-ft-action-btn:active {
    transform: scale(0.95);
}

.sa-ft-action-btn small {
    font-size: 12px;
}

/* 2. Stilizzazione dell'icona del calendario (Chrome, Edge, Safari) */
.sa-ft-date-input::-webkit-calendar-picker-indicator {
    cursor: pointer;
    opacity: 0.6;
    filter: invert(40%) sepia(10%) saturate(1000%) hue-rotate(180deg);
    /* Cambia colore all'iconcina se vuoi */
    transition: opacity 0.2s;
}

.sa-ft-date-input::-webkit-calendar-picker-indicator:hover {
    opacity: 1;
}

/* 3. Rimuove lo spinner (le freccette su/giù) se presente */
.sa-ft-date-input::-webkit-inner-spin-button,
.sa-ft-date-input::-webkit-clear-button {
    display: none;
    -webkit-appearance: none;
}

.sa-ft-form-select {
    border: none !important;
    background: transparent !important;
    font-size: 0.88rem !important;
    font-weight: 600 !important;
    color: #333;
    outline: none;
    padding: 0 !important;
    width: 100% !important;
    cursor: pointer;



    /* Aggiunge una freccia personalizzata (SVG pulito) */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2364748b' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E") !important;
    background-repeat: no-repeat !important;
    background-position: right 2px center !important;
    background-size: 10px !important;
    padding-right: 20px !important;
    /* Spazio per la freccia */
}

/* Fix per IE/Edge */
.sa-ft-form-select::-ms-expand {
    display: none;
}

/* Stile per le opzioni (limitato dal browser, ma aiuta) */
.sa-ft-form-select option {
    background-color: #ffffff;
    color: #333;
    font-weight: 500;
}

::v-deep .mx-datepicker,
.mx-datepicker {
    width: 100% !important;
}

::v-deep .mx-input,
.mx-input {
    /* RESET TOTALE */
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;

    /* ALLINEAMENTO */
    padding: 0 !important;
    margin: 0 !important;
    height: 22px !important;
    /* Forza l'altezza bassa */
    min-height: 22px !important;

    /* TESTO COERENTE */
    font-size: 0.88rem !important;
    font-weight: 600 !important;
    color: #333 !important;
    line-height: 1.2 !important;
}

/* Rimuove l'alone azzurro quando ci clicchi sopra */
::v-deep .mx-input:focus,
.mx-input:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
}

/* Sistema l'icona interna del componente */
::v-deep .mx-icon-calendar,
.mx-icon-calendar {
    font-size: 14px;
    right: 5px;
    color: #94a3b8;
}

/* Tablet e Desktop piccoli */
@media (max-width: 1024px) {
    .sa-ft-split-wrapper {
        flex-direction: column;
        /* Impila Residenza e Domicilio */
        gap: 30px;
    }

    .sa-ft-divider-vertical {
        width: 100%;
        height: 1px;
        background: linear-gradient(to right, transparent, #e2e8f0, transparent);
    }
}

/* Smartphone */
@media (max-width: 768px) {
    .sa-ft-form-card {
        padding: 15px;
        /* Riduciamo il padding interno */
    }

    .sa-ft-grid {
        flex-direction: column;
        /* Quasi tutto su una colonna */
        gap: 10px;
    }

    /* Eccezione: manteniamo mini-griglie per campi brevi se vuoi (es. Sesso e Gruppo Sanguigno) */
    .sa-ft-grid-mobile-row {
        flex-direction: row !important;
    }

    /* Allineamento Icone */
    .sa-ft-icon-box {
        margin-right: 8px;
        font-size: 1rem;
    }

    /* Il bottone Verifica scende sotto l'input o resta a lato? 
     Meglio resti a lato ma con testo ridotto se necessario */
    .sa-ft-action-btn span {
        display: none;
        /* Nascondiamo il testo "Verifica" su mobile per salvare spazio */
    }

    .sa-ft-action-btn {
        padding: 8px;
    }

    /* Gestione CAP e Provincia su mobile */
    .flex-fixed-cap {
        width: 70px;
    }

    .flex-fixed-prov {
        width: 55px;
    }
}

/* Ottimizzazione per schermi molto piccoli */
@media (max-width: 480px) {
    .sa-ft-card-header h3 {
        font-size: 0.85rem;
    }

    .sa-ft-inner-row {
        gap: 8px;
    }
}
</style>